module.exports = __webpack_public_path__ + "img/wesite_pic_1@3x.d0cb9bfc.png";